export default {
    welcome: 'Welcome to the',
    poweredby: 'Powered by <strong>Trendexplorer</strong>, a product of &copy; <em>TRENDONE GmbH</em>',
    form: {
        title: 'Login',
        forgottenPassword: 'Forgot password?',
        email: {
            label: 'E-mail',
            error: {
                required: 'Please enter your e-mail address',
                email: 'Please enter a valid e-mail address'
            }
        },
        password: {
            label: 'Password',
            error: 'Please enter your password'
        },
        action: 'Log in'
    },
    sso: 'Login via Azure-AD',
    pageTitle: 'LOGIN'
}
